<template>


    <div>


      <div v-if="Type==1">
        <div class="ColGroupBlockM" :style="gridParams">
        <div class="TitleBlockM">
          {{this.Message}}
        </div>
        </div>
      </div>
      <div v-if="Type==2">
        <div class="ColGroupBlockM2" :style="gridParams">
        <div class="TitleBlockM2">
          {{this.Message+1}}
        </div>
        </div>
      </div>
      <div v-if="Type==3">
        <div class="ColGroupBlockM3" :style="gridParams">
        <div class="TitleBlockM3">
          {{this.Message}}
        </div>
      </div>
      </div>
      <!-- {{this.ColStart}}x{{this.ColEnd}}|{{this.RowStart}}x{{this.RowEnd}} -->
    </div>


</template>


<style lang="css" type="text/css">

.ColGroupBlockM {

  left: var(--ColStart);
  top: var(--RowStart);
  width: var(--Width);
  height: var(--Height);
  border: 1px solid #003950;

  /* grid-column: col var(--ColStart)/var(--ColEnd);
  grid-row: row  var(--RowStart)/var(--RowEnd); */
}

.ColGroupBlockM2 {
  position: relative;
  left: var(--ColStart);
  top: var(--RowStart);
  width: var(--Width);
  height: var(--Height);
  border: 1px solid #0039502b;

  /* grid-column: col var(--ColStart)/var(--ColEnd);
  grid-row: row  var(--RowStart)/var(--RowEnd); */
}

.ColGroupBlockM3 {

  left: var(--ColStart);
  top: var(--RowStart);
  width: var(--Width);
  height: var(--Height);
  /* border: 1px solid #003950; */

  /* grid-column: col var(--ColStart)/var(--ColEnd);
  grid-row: row  var(--RowStart)/var(--RowEnd); */
}

.TitleBlockM {
  position: relative;
  border: 1px solid #ffffff;
  background-color: #003950;
  color: #fff;
  border-radius: 0px;
  padding: 1px;
  font-size: 100%;

  left: 1;
  top: 1;
  width: var(--Width);
  height: 15px;
}

.TitleBlockM2 {
  position: relative;
  border: 1px solid  #003950;
  /* background-color: #003950; */
  color: #003950;
  border-radius: 0px;
  padding: 0px;
  font-size: 100%;

  left: 1;
  top: 100px;
  width: var(--Width);
  height: 105px;
}

.TitleBlockM3 {
  position: relative;

  /* border: 0px solid #ffffff; */
  /* background-color: #003950; */
  color: #003950;
  /* border-radius: 0px; */
  padding: 0px;
  font-size: 55%;

  left: 1;
  top: 1;
  width: var(--Width);
  height: 15px;
}
</style>

<script>


export default {
  name: 'TimelineGridColGroupMonth',
  components: {

  },
	props: {
    ColStart: {
      default: 1
    },
    ColEnd: {
      default: 10
    },
    RowStart: {
      default: 1
    },
    RowEnd: {
      default: 10
    },
    Message: {
      default: "I am a message"
    },
    Type: {
      default: 1
    }



	},

  data: function () {
    return {
      colWidth: 10,
      rowHeight: 30
    }
  },

  methods: {



  },
  watch: {


  },
  computed: {
    gridParams () {

      if(this.Type==1){

        var x = {

          '--ColStart': `${this.ColStart}px`,
          '--ColEnd': `${this.ColEnd}px`,
          '--Width': `${this.ColEnd-this.ColStart}px`,
          '--Height': `${(this.RowEnd-this.RowStart)*this.rowHeight}px`,

          '--RowStart': `${this.RowStart*this.rowHeight*55}px`,
          '--RowEnd': `${this.RowEnd*this.rowHeight*55}px`


        }

      }else if (this.Type==2) {
        var x = {

          '--ColStart': `${this.ColStart}px`,
          '--ColEnd': `${this.ColEnd}px`,
          '--Width': `${this.ColEnd-this.ColStart}px`,
          '--Height': `${(this.RowEnd-this.RowStart)*this.rowHeight}px`,

          '--RowStart': `${this.RowStart*this.rowHeight+10}px`,
          '--RowEnd': `${this.RowEnd*this.rowHeight+10}px`


        }
      }else if (this.Type==3) {
        var x = {

          '--ColStart': `${this.ColStart}px`,
          '--ColEnd': `${this.ColEnd}px`,
          '--Width': `${this.ColEnd-this.ColStart}px`,
          '--Height': `${(this.RowEnd-this.RowStart)*this.rowHeight}px`,

          '--RowStart': `${this.RowStart*this.rowHeight}px`,
          '--RowEnd': `${this.RowEnd*this.rowHeight}px`


        }
      }
      return x
    },

  }

}
</script>
